import { render, staticRenderFns } from "./KioskTablesPreset.vue?vue&type=template&id=1c132822&scoped=true&"
import script from "./KioskTablesPreset.vue?vue&type=script&lang=js&"
export * from "./KioskTablesPreset.vue?vue&type=script&lang=js&"
import style0 from "./KioskTablesPreset.vue?vue&type=style&index=0&id=1c132822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c132822",
  null
  
)

export default component.exports